import { render, staticRenderFns } from "./GoodsCzzy.vue?vue&type=template&id=85cf4bc0&scoped=true"
import script from "./GoodsCzzy.vue?vue&type=script&lang=js"
export * from "./GoodsCzzy.vue?vue&type=script&lang=js"
import style0 from "./GoodsCzzy.vue?vue&type=style&index=0&id=85cf4bc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cf4bc0",
  null
  
)

export default component.exports